<button
  *ngIf="buttonType === 'button' || buttonType === 'icon-button'"
  [ngClass]="buttonClasses"
  (click)="handleButtonClick()"
  [attr.data-toggle]="buttonLink === '' ? 'modal' : ''"
  [attr.data-target]="buttonLink === '' ? '#modal' : ''"
>
  {{ buttonText }} <i class="dx-icon-{{ buttonIcon }}"></i>
</button>

<a class="yellow-text" *ngIf="buttonType === 'link'"
  >{{ buttonText }} <i class="dx-icon-{{ buttonIcon }}"></i
></a>
<a *ngIf="buttonType === 'email-link'" href="mailto: info@medigi.com"
  >{{ buttonText }} <i class="dx-icon-{{ buttonIcon }}"></i
></a>

<div
  id="modal"
  class="modal fade"
  data-keyboard="false"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="top-row">
        <img
          class="close-icon m-2"
          data-dismiss="modal"
          aria-label="Close"
          src="/assets/img/static-pages/medigi/v2-images/standalone-icons/close-icon-blue.svg"
          alt=""
        />
      </div>
      <div class="modal-body">
        <h3 class="mdg-blue">
          Send us a message, and a representative will reach out
        </h3>
        <app-static-form formType="general"></app-static-form>
      </div>
    </div>
  </div>
</div>
